import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker
,GetImgCertUser_CBack,RespBkMthdMapp_CBack} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';


import defaultPic from '../assets/images/9.png';
import Comp_Cadet_Record_Book from '../lms_component/comp_cadet_record_book';
import Comp_View_Pdf from '../lms_component/comp_view_pdf';
import Comp_Stu_Submit_Task from '../lms_component/comp_stu_submit_task';
import Comp_CRB_New from '../lms_component/comp_crb_new';
//import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';


let loginUser="";
let userObject="";
let companyName="";
let clsCRB;

let rf="0";
class Cadet_Record_Book extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stListClassFee:[],stSetHrfPdf:"",stListTask:[]};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsCRB=this;
      }
   
     
    getSubTask(){
        var map=[];
        map.push({name:"curl_type",value:"getSubTaskCRB"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        
       
        map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getSubTaskCRB";
        CallMapMethod_CBack(clsCRB,map,function(data,msg){
          // alert(data);
          if(data!=="0" && data!==""){
            let listData=JSON.parse(data);
            //stLsCurriculam
            clsCRB.setState({stListTask:listData},()=>{
              
RespBkMthdMapp_CBack(clsCRB,"e_click_class",function(event){
  let chref=event.target.getAttribute("chrf")
  //alert();
  if(!window.memc_system){
    //alert("I m in mec");
  clsCRB.setState({stSetHrfPdf:chref},()=>{
      clsCRB.forceUpdateHandler();
      $("#divPdfView").modal('show');
  })
}else{
  alert("Option not activated, kindly go Tasklist to submit/process the task");
}     
      //alert(JSON.stringify(data));
      //props.runSearch(data);
    },"chrf");
            });
          }
        })

  }

      
       
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);


clsCRB.getSubTask();

}




      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
   
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card card-secondary">
              {/* <!-- /.card-header --> */}
           <div class="card-header">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Cadet Record Book Guidelines</b></h3>
                {/* <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divSessionYear" href="javascript:void(0)">Add New</a> */}
              </div>
              <form class="form-group" id="frmStudentBulkImport" name="frmStudentBulkImport" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">  
            <div className="card-body">
               <Comp_CRB_New task_list={this.state.stListTask}/>
               {/* <Comp_Cadet_Record_Book/> */}
                                  

               
               

                                <div className="col-md-6 respSSL"></div>
                                <div id="updResponsePro"></div>
                                <div class="row">
                                    <div class="col-12">
                                      
                                        <div class="form-group">
                                        <center>
                                            <div class="input-group input-group-sm" style={{"justify-content":"center"}}>
                                                <button type="button" onClick={()=>this.saveWappCompaign()} class="btn btn-primary">Update Now</button>
                                            </div>
                                        </center>
                                        </div>
                                        
                                    </div>
                                </div>                    
            </div>   
            </form>   
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Comp_View_Pdf hrfPdf={this.state.stSetHrfPdf} proItem={this.state.stItemProduct} />
<Comp_Stu_Submit_Task hrfPdf={this.state.stSetHrfPdf} proItem={this.state.stItemProduct}/>
<Alert_Content/>
<Footer/>

    {/* <Wa_Credit_Balance_Comp creditUser={this.state.crediUser} creditBalance={this.state.creditBalance} masterBalance={this.state.masterBalance} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default Cadet_Record_Book;